import React from 'react';

const SvgComponent = (props) => (
  <svg viewBox="0 0 18 18" width="1em" height="1em" {...props}>
    <path d="M9.773 12.539C9.609 12.89 8.208 13.8 5.5 13.8c-2.744 0-4.15-.936-4.282-1.264-.4-.173-.762-.37-1.077-.591A1.242 1.242 0 0 0 0 12.5C0 13.881 2.462 15 5.5 15s5.5-1.119 5.5-2.5c0-.191-.052-.376-.141-.555a5.976 5.976 0 0 1-1.086.594z" />
    <path d="M9.773 15.539C9.609 15.89 8.208 16.8 5.5 16.8c-2.744 0-4.15-.936-4.282-1.264-.4-.173-.762-.37-1.077-.591A1.242 1.242 0 0 0 0 15.5C0 16.881 2.462 18 5.5 18s5.5-1.119 5.5-2.5c0-.191-.052-.376-.141-.555a5.976 5.976 0 0 1-1.086.594zM11.5 0L5.812 5.688c.547.012 1.072.054 1.57.126L11.5 1.697l5.3 5.299v5.785H14V7h-3.221c.514.346.91.751 1.173 1.2h.848v5.781H18V6.499L11.5 0z" />
    <path d="M5.5 7C2.462 7 0 8.119 0 9.5S2.462 12 5.5 12 11 10.881 11 9.5 8.538 7 5.5 7zm0 3.8c-2.817 0-4.235-.991-4.301-1.294C1.265 9.191 2.683 8.2 5.5 8.2s4.235.991 4.301 1.294C9.735 9.809 8.317 10.8 5.5 10.8z" />
  </svg>
);

export default SvgComponent;
